import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-carousel c-carousel--roundedArrow" }
const _hoisted_2 = {
  ref: "prevEl",
  class: "c-carousel__prev"
}
const _hoisted_3 = {
  ref: "nextEl",
  class: "c-carousel__next"
}
const _hoisted_4 = {
  ref: "paginationEl",
  class: "c-carousel__pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Swiper, {
      ref: "carouselRef",
      modules: _ctx.swiperModules,
      "slides-per-view": _ctx.slidesPerView,
      "space-between": _ctx.spaceBetween,
      loop: _ctx.loop,
      "centered-slides": _ctx.centeredSlides,
      autoplay: _ctx.autoplayOption,
      breakpoints: _ctx.breakpointsOption,
      navigation: { prevEl: _ctx.prevEl, nextEl: _ctx.nextEl },
      pagination: { el: _ctx.paginationEl, clickable: true }
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    }, 8, ["modules", "slides-per-view", "space-between", "loop", "centered-slides", "autoplay", "breakpoints", "navigation", "pagination"]),
    _createElementVNode("div", _hoisted_2, _cache[0] || (_cache[0] = [
      _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      }, [
        _createElementVNode("path", {
          d: "M15 18l-6-6 6-6",
          stroke: "currentColor",
          "stroke-width": "2",
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]), 512),
    _createElementVNode("div", _hoisted_3, _cache[1] || (_cache[1] = [
      _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        width: "24",
        height: "24"
      }, [
        _createElementVNode("path", {
          d: "M9 6l6 6-6 6",
          stroke: "currentColor",
          "stroke-width": "2",
          fill: "none",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]), 512),
    _createElementVNode("div", _hoisted_4, null, 512)
  ]))
}